import { Expose } from "class-transformer";
import { IsNumber, IsString } from "class-validator";

export class FileTmp {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string;
}

export class FileGuid {
  @IsString()
  @Expose()
  id!: string;
  @IsString()
  @Expose()
  name!: string;
}
